import React from "react";
import { FaLinkedin, FaInstagram, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { useLocalizedStrings } from "../Localization";  
import memoji from "../assets/contact_memoji.png";

const Contact = () => {
  const strings = useLocalizedStrings();

  return (
    <div className="flex justify-center items-center py-20">
      <div className="relative md:w-[80%] w-[90%] flex md:flex-row flex-col items-center bg-[#B7B1F2] border-4 border-black rounded-xl p-10 shadow-lg">
        
        {/* Başlık */}
        <div 
          id="contact" 
          className="absolute -top-14 left-5 bg-black text-white px-4 py-2 text-4xl rounded-t-lg"
          style={{ fontFamily: 'Bokor' }}
        >
          {strings.contactMe}
        </div>

        {/* Sol Kısım: Büyük Başlık */}
        <div className="md:w-3/5 h-1/2 md:text-left pb-6 md:pb-0 text-center">
          <h2 
            className="md:text-6xl text-2xl font-bold text-black leading-snug"
            style={{ fontFamily: 'Emblema One' }}
          >
            {strings.messageMe}
          </h2>
        </div>

        {/* Orta Kısım: Resim + Gölge */}
        <div className="md:w-1/5 hidden md:flex justify-center relative">
          <img 
            src={memoji} 
            alt="Memoji" 
            className="w-40 h-full object-contain drop-shadow-2xl contrast-110 brightness-110"
          />
          <div className="absolute bottom-0 w-32 h-6 bg-black opacity-30 rounded-full blur-lg"></div>
        </div>

        {/* Sağ Kısım: Sosyal Medya İkonları */}
        <div className="md:w-1/5 h-1/2 flex md:flex-col flex-row items-center space-x-6 md:space-y-6">
          <a 
            href="https://linkedin.com/in/oyelmali" 
            target="_blank" 
            rel="noopener noreferrer"
            className="md:w-16 md:h-16 w-12 h-12 flex items-center justify-center bg-blue-600 text-white text-4xl rounded-full shadow-lg hover:bg-blue-800 hover:scale-110 transition-all"
            aria-label={strings.linkedin}
          >
            <FaLinkedin />
          </a>

          <a 
            href="https://instagram.com/yusuffelmali" 
            target="_blank" 
            rel="noopener noreferrer"
            className="md:w-16 md:h-16 w-12 h-12 flex items-center justify-center bg-pink-500 text-white text-4xl rounded-full shadow-lg hover:bg-pink-700 hover:scale-110 transition-all"
            aria-label={strings.instagram}
          >
            <FaInstagram />
          </a>

          <a 
            href="mailto:omer.yusuf.elmali@gmail.com" 
            className="md:w-16 md:h-16 w-12 h-12 flex items-center justify-center bg-gray-600 text-white text-4xl rounded-full shadow-lg hover:bg-gray-800 hover:scale-110 transition-all"
            aria-label={strings.email}
          >
            <FaEnvelope />
          </a>

          <a 
            href="https://wa.me/5388229728" 
            target="_blank" 
            rel="noopener noreferrer"
            className="md:w-16 md:h-16 w-12 h-12 flex items-center justify-center bg-green-500 text-white text-4xl rounded-full shadow-lg hover:bg-green-700 hover:scale-110 transition-all"
            aria-label={strings.whatsapp}
          >
            <FaWhatsapp />
          </a>
        </div>

      </div>
    </div>
  );
};

export default Contact;
